import { reactive } from "vue";

/**
 * 路由数据
 */
export const routerList = reactive<any[]>([
  {
    index: '1',
    path: '/',
    name: '网站首页'
  },
  {
    index: '2',
    path: '/aboutview',
    name: '关于我们',
    children: [
      {
        index: '2-1',
        path: '/learnabout',
        name: '学会概况',
        children: [
          {
            index: '2-1-1',
            path: '/learnaboutIntroduction',
            name: '学会简介'
          },
          {
            index: '2-1-2',
            path: '/learnaboutRules',
            name: '学会章程'
          },
          {
            index: '2-1-3',
            path: '/learnaboutCouncil',
            name: '第二届理事会'
          },
        ]
      },
      {
        index: '2-2',
        path: '/xiehuiabout',
        name: '协会概况',
        children: [
          {
            index: '2-2-1',
            path: '/xiehuiaboutIntroduction',
            name: '协会简介'
          },
          {
            index: '2-2-2',
            path: '/xiehuiaboutRules',
            name: '协会章程'
          },
          {
            index: '2-2-3',
            path: '/xiehuiaboutCouncil',
            name: '第二届理事会'
          },
        ]
      }
    ]
  },
  {
    index: '3',
    path: '/cultureBuilding',
    name: '党建文化',
    children: [
      {
        index: '3-1',
        path: '/dangjian',
        name: '党建动态'
      },
      {
        index: '3-2',
        path: '/dangzhang',
        name: '党章党规'
      },
    ]
  },
  {
    index: '4',
    path: '/four',
    name: '政策规范',
    children: [
      {
        index: '4-1',
        path: '/policyAndfg',
        name: '政策法规'
      },
      {
        index: '4-1',
        path: '/learnRules',
        name: '学会规章制度'
      },
      {
        index: '4-3',
        path: '/xiehuiRules',
        name: '协会规章制度'
      },
    ]
  },
  {
    index: '5',
    path: '/five',
    name: '卫生强基',
    children: [
      {
        index: '5-1',
        path: '/weisheng',
        name: '基层巡讲'
      },
    ]
  },
  {
    index: '6',
    path: '/six',
    name: '大讲堂',
    children: [
      {
        index: '6-1',
        path: '/jiangtang',
        name: '生活方式医学与慢病管理大讲堂'
      },
    ]
  },
  {
    index: '7',
    path: '/notice',
    name: '信息发布',
    children: [
      {
        index: '7-1',
        path: '/learnNotice',
        name: '学会通知公告',
      },
      {
        index: '7-2',
        path: '/learnwork',
        name: '学会工作动态',
      },
      {
        index: '7-3',
        path: '/xiehuinotice',
        name: '协会通知公告',
      },
      {
        index: '7-4',
        path: '/xiehuiwork',
        name: '协会工作动态',
      },
      // {
      //   index: '7-5',
      //   path: '/xiehuiNotice',
      //   name: '会议管理',
      // },
    ]
  },
  {
    index: '8',
    path: '/spreadField',
    name: '科普园地',
    children: [
      {
        index: '8-1',
        path: '/danao',
        name: '大脑健康'
      },
      {
        index: '8-2',
        path: '/shuimian',
        name: '睡眠健康'
      },
    ]
  },
  {
    index: '9',
    path: '/branch',
    name: '分支机构',
    children: [
      // {
      //   index: '9-1',
      //   path: '/learnBranch?id=1',
      //   name: '学会分支机构',
      //   children: [
      //     {
      //       index: '9-1-1',
      //       path: '/chairman?id=1&type=1',
      //       name: '神经影像学分会',
      //     },
      //     {
      //       index: '9-1-2',
      //       path: '/chairman?id=1&type=2',
      //       name: '神经病学分会',
      //     },
      //     {
      //       index: '9-1-3',
      //       path: '/chairman?id=1&type=3',
      //       name: '睡眠医学分会',
      //     },
      //     {
      //       index: '9-1-4',
      //       path: '/chairman?id=1&type=4',
      //       name: '神经生物学分会',
      //     },
      //     {
      //       index: '9-1-5',
      //       path: '/chairman?id=1&type=5',
      //       name: '人工智能与类脑研究分会',
      //     },
      //     {
      //       index: '9-1-6',
      //       path: '/chairman?id=1&type=6',
      //       name: '远程医疗与大数据分会',
      //     },
      //     {
      //       index: '9-1-7',
      //       path: '/chairman?id=1&type=7',
      //       name: '精神病学基础与临床分会',
      //     },
      //     {
      //       index: '9-1-8',
      //       path: '/chairman?id=1&type=8',
      //       name: '行为与健康学分会',
      //     },
      //     {
      //       index: '9-1-9',
      //       path: '/chairman?id=1&type=9',
      //       name: '神经免疫分会',
      //     },
      //     {
      //       index: '9-1-10',
      //       path: '/chairman?id=1&type=10',
      //       name: '神经护理学分会',
      //     },
      //     {
      //       index: '9-1-11',
      //       path: '/chairman?id=1&type=11',
      //       name: '中医脑科学分会',
      //     },
      //     {
      //       index: '9-1-12',
      //       path: '/chairman?id=1&type=12',
      //       name: '重症肌无力及相关疾病多学科委员会',
      //     },
      //     {
      //       index: '9-1-13',
      //       path: '/chairman?id=1&type=13',
      //       name: '神经感染分会',
      //     },
      //     {
      //       index: '9-1-14',
      //       path: '/chairman?id=1&type=14',
      //       name: '神经康复分会',
      //     },
      //     {
      //       index: '9-1-15',
      //       path: '/chairman?id=1&type=15',
      //       name: '神经外科学分会',
      //     },
      //     {
      //       index: '9-1-16',
      //       path: '/chairman?id=1&type=16',
      //       name: '麻醉与脑功能分会',
      //     },
      //     {
      //       index: '9-1-17',
      //       path: '/chairman?id=1&type=17',
      //       name: '生活方式医学与慢病防治专业委员会',
      //     },
      //     {
      //       index: '9-1-18',
      //       path: '/chairman?id=1&type=18',
      //       name: '医护融合专业委员会',
      //     },
      //     {
      //       index: '9-1-19',
      //       path: '/chairman?id=1&type=19',
      //       name: '肿瘤学分会',
      //     },
      //   ]
      // },
      // {
      //   index: '9-2',
      //   path: '/learnBranch?id=2',
      //   name: '协会分支机构',
      //   children: [
      //     {
      //       index: '9-2-1',
      //       path: '/chairman?id=2&type=1',
      //       name: '检验医学与转化分会',
      //     },
      //     // {
      //     //   index: '10-2-2',
      //     //   path: '/chairman?id=2&type=2',
      //     //   name: '中医分会',
      //     // },
      //   ]
      // },
      {
        index: '9-1',
        path: '/learn_branch',
        name: '学会分支机构',
      },
      {
        index: '9-2',
        path: '/xiehui_branch',
        name: '协会分支机构',
      },
    ]
  },
  // {
  //   index: '11',
  //   path: '/downloadZone',
  //   name: '下载专区',
  //   children: [
  //     {
  //       index: '11-1',
  //       path: '/learnZone',
  //       name: '学会下载专区'
  //     },
  //     {
  //       index: '11-2',
  //       path: '/xiehuiZone',
  //       name: '协会下载专区'
  //     },
  //   ]
  // },
])